import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  @Input() title?: string;
  @Input() message?: string;
  @Input() confirmationBtnText = $localize`Tak`;
  @Input() declineBtnText = $localize`Nie`;
  disabledButton = false;

  @Output() emitData = new EventEmitter<boolean>();

  constructor(private readonly modalRef: BsModalRef) {}

  confirm(): void {
    this.disabledButton = true;
    this.emitData.emit(true);
    this.modalRef.hide();
  }

  decline(): void {
    this.emitData.emit(false);
    this.modalRef.hide();
  }
}
